<template>
  <AnalyticsSkeleton>
    <Upselling
      class="absolute z-10 p-8 text-center bg-white border rounded-10 shadow-lg top-4 lg:top-8 right-4 lg:right-32 bottom-4 left-8 lg:left-32 dark:bg-zinc-600 border-slate-300 dark:border-zinc-600"
      header="Advanced Analytics"
      message="Make and measure impact. See the results of what you create, including who viewed your content, view count, and percentage of content viewed."
      cta="Upgrade to Pro"
      data-testid="analytics-tab-upselling"
      @cta-click="onClick"
    />
  </AnalyticsSkeleton>
</template>

<script lang="ts" setup>
import AnalyticsSkeleton from './AnalyticsSkeleton.vue';
import Upselling from '@/components/Upselling.vue';
import { useViewerTrack, TrackEvents } from '@/modules/viewer/composables/useViewerTrack';

const { trackItemOwner } = useViewerTrack();

const onClick = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();
  trackItemOwner(TrackEvents.UPGRADE_CLICK)
    .finally(() => {
      window.location.assign('/account/plans');
    })
    .catch(() => {});
};
</script>
